var map = {
	"./assert.d.ts": 4709,
	"./async_hooks.d.ts": 4954,
	"./base.d.ts": 7377,
	"./buffer.d.ts": 3736,
	"./child_process.d.ts": 4787,
	"./cluster.d.ts": 902,
	"./console.d.ts": 7516,
	"./constants.d.ts": 9389,
	"./crypto.d.ts": 1025,
	"./dgram.d.ts": 4981,
	"./dns.d.ts": 8887,
	"./domain.d.ts": 323,
	"./events.d.ts": 7823,
	"./fs.d.ts": 8966,
	"./fs/promises.d.ts": 1942,
	"./globals.d.ts": 2923,
	"./globals.global.d.ts": 6385,
	"./http.d.ts": 7379,
	"./http2.d.ts": 1519,
	"./https.d.ts": 6819,
	"./index.d.ts": 4104,
	"./inspector.d.ts": 5566,
	"./module.d.ts": 5792,
	"./net.d.ts": 7030,
	"./os.d.ts": 7719,
	"./path.d.ts": 4572,
	"./perf_hooks.d.ts": 288,
	"./process.d.ts": 1503,
	"./punycode.d.ts": 5764,
	"./querystring.d.ts": 2093,
	"./readline.d.ts": 6968,
	"./repl.d.ts": 6932,
	"./stream.d.ts": 9606,
	"./string_decoder.d.ts": 9746,
	"./timers.d.ts": 2316,
	"./tls.d.ts": 6516,
	"./trace_events.d.ts": 9471,
	"./ts3.4/assert.d.ts": 5127,
	"./ts3.4/base.d.ts": 231,
	"./ts3.4/globals.global.d.ts": 5718,
	"./ts3.4/index.d.ts": 1598,
	"./ts3.6/base.d.ts": 1158,
	"./ts3.6/index.d.ts": 446,
	"./tty.d.ts": 1514,
	"./url.d.ts": 8460,
	"./util.d.ts": 3832,
	"./v8.d.ts": 3949,
	"./vm.d.ts": 1812,
	"./wasi.d.ts": 3080,
	"./worker_threads.d.ts": 3018,
	"./zlib.d.ts": 6803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4917;